import { React, useState, useEffect } from "react";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { DatePicker } from "@mui/x-date-pickers";
import { Grid, Typography, useTheme, useMediaQuery, Box } from "@mui/material";
import { useTranslation } from 'react-i18next';
import CopyButton from '../common/CopyButton';
import {
  CalculatorContainer,
  CalculatorTitle,
  DateContainer,
  ResultTypography,
  datePickerStyles
} from '../../shared/styles';

// dayjs에 ISO 주차 플러그인 추가
dayjs.extend(isoWeek);

function WeekCalculator() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [weekInfo, setWeekInfo] = useState({
    weekNumber: 0,
    year: 0,
    startDate: null,
    endDate: null
  });

  useEffect(() => {
    const weekNumber = selectedDate.isoWeek();
    const year = selectedDate.year();
    const startDate = selectedDate.startOf('isoWeek');
    const endDate = selectedDate.endOf('isoWeek');

    setWeekInfo({
      weekNumber,
      year,
      startDate,
      endDate
    });
  }, [selectedDate]);

  const resultTitle = t('weekCalc.week', { week: weekInfo.weekNumber }) + `, ${weekInfo.year}`;
  const resultText = `${resultTitle}\n` +
    `From: ${weekInfo.startDate?.format('YYYY-MM-DD')}\n` +
    `To: ${weekInfo.endDate?.format('YYYY-MM-DD')}`;

  return (
    <CalculatorContainer>
      <CalculatorTitle variant={isMobile ? "h5" : "h4"}>
        {t('weekCalc.title')}
      </CalculatorTitle>
      <Grid
        container
        spacing={isMobile ? 2 : 3}
        justifyContent="center"
        sx={{ flexGrow: 1 }}
      >
        <Grid item xs={12}>
          <DateContainer>
            <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
              {t('weekCalc.date')}
            </Typography>
            <DatePicker
              onChange={setSelectedDate}
              value={selectedDate}
              sx={datePickerStyles}
            />
          </DateContainer>
        </Grid>
      </Grid>
      <ResultTypography
        variant={isMobile ? "h6" : "h5"}
        sx={{
          mt: 'auto',
          mb: 2,
          whiteSpace: 'pre-line',
          textAlign: 'left',
          padding: 2,
          backgroundColor: 'rgba(187, 222, 251, 0.2)',
          borderRadius: 2,
        }}
      >
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1
        }}>
          <Typography variant="h6" color="primary">
            Week {weekInfo.weekNumber}, {weekInfo.year}
          </Typography>
          <Typography>
            From: {weekInfo.startDate?.format('YYYY-MM-DD')}
          </Typography>
          <Typography>
            To: {weekInfo.endDate?.format('YYYY-MM-DD')}
          </Typography>
        </Box>
        <Box sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
        }}>
          <CopyButton text={resultText} />
        </Box>
      </ResultTypography>
    </CalculatorContainer>
  );
}

export default WeekCalculator; 